import { Component, inject } from '@angular/core';
import { ModalService } from '../../services/modal/modal.service';

/**
 * ModalOutlet
 *
 * Placed once in the app root. Reads from ModalService and renders
 * the active modal (backdrop + dialog) when one is present.
 */
@Component({
  selector: 'app-modal-outlet',
  imports: [],
  templateUrl: './modal-outlet.html',
  styleUrl:    './modal-outlet.scss',
})
export class ModalOutlet {
  protected modal = inject(ModalService);
}
